import { render } from "./AddTagTemplateWizard.vue?vue&type=template&id=22c7de50"
import script from "./AddTagTemplateWizard.vue?vue&type=script&lang=js"
export * from "./AddTagTemplateWizard.vue?vue&type=script&lang=js"

import "./AddTagTemplateWizard.vue?vue&type=style&index=0&id=22c7de50&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__